import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AiSettingsService } from '../../service/ai-settings.service';
import { AiFeatureRequirement, isAiFeatureEnabled } from './ai-settings';

export const AI_DISABLED_REDIRECT = '/';

export function aiFeatureGuard(requirement: AiFeatureRequirement): CanActivateFn {
  return () => {
    const router = inject(Router);
    return inject(AiSettingsService)
      .loadOnce()
      .pipe(map((v) => (isAiFeatureEnabled(v, requirement) ? true : router.parseUrl(AI_DISABLED_REDIRECT))));
  };
}
